<template>
    <div class="user-delete-class-form">
        <div class="delete-class-body">
            <b-form data-vv-scope="user-delete-class-form">
                <b-row class="kelas">
                    <b-col sm="12">
                        <b-form-group
                            label="Kelas"
                            label-for="class_id"
                            label-cols-sm="3"
                            label-align-sm="left"
                        >
                            <b-form-select
                                v-model="delete_class_form.class_id"
                                name="class_id"
                                value-field="id"
                                text-field="name"
                                data-vv-as="Kelas"
                                :options="userClassList"
                                v-validate="'required'"
                            ></b-form-select>
                            <span :class="{ 'error-validation': errors.first('user-delete-class-form.class_id') }">{{ errors.first('user-delete-class-form.class_id') }}</span>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </div>
        <hr>
        <div class="delete-class-footer d-flex justify-content-end">
            <b-button variant="outline-danger" size="md" style="width: 25%;" @click="hideDeleteClassModal">BATAL</b-button>
            <b-button variant="primary" size="md" style="width: 25%;" @click.prevent="confirmDelete">Hapus</b-button>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { EventBus } from '@/eventBus.js'
    export default {
        props: {
            id: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                delete_class_form: {
                    class_id: null,
                    user_id: this.id
                }
            }
        },
        computed: {
          ...mapGetters({
              userClassList: 'getUserClassListCombineTa'
          })
        },
        methods: {
            resetDeleteClassForm() {
                this.delete_class_form.class_code = null
                this.$validator.reset()
            },
            hideDeleteClassModal() {
                EventBus.$emit('hideDeleteClassModal', true)
            },
            confirmDelete() {
                let scope = 'user-delete-class-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        this.$swal.fire({
                            title: 'Apakah anda yakin?',
                            text: '',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Ya, saya yakin',
                            cancelButtonText: 'Tidak'
                        }).then((result) => {
                            if (result.value) {
                                let form = this.delete_class_form
                                this.deleteMemberClass(form)
                            }
                        })
                    }
                });
            },
            async deleteMemberClass(id) {
				await this.$store.dispatch('deleteMemberClass', { id })
					.then((res) => {
                        this.$store.dispatch('getOverview')
                        this.$store.dispatch('getClassList')
                        this.hideDeleteClassModal()
                        this.$swal.fire('Success', res.message, 'success')
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
            },
            async getUserClassListCombineTa(userId) {
                await this.$store.dispatch('getUserClassListCombineTa', { userId })
                    .then(() => {
                    })
                    .catch((err)=> {
                    this.$swal.fire('Failed', err.response.data.message, 'error')
                    })
            },
        },
		created () {
			EventBus.$on('resetDeleteClassForm', (val) => {
				if (val) {
					this.resetDeleteClassForm()
				}
			})
            this.getUserClassListCombineTa(this.id)
        }
    }
</script>